$(document).ready(function() {
    const order = {
        isLoadingOrder: false,
        init() {
            $(document).on('click', '#order-form-btn', this, this.submitForm);
            $(document).on('click', '.billing-tab', this, this.billingTab);
            $(document).on('click', '.billing-address', this, this.selectBillingAddress);
            $(document).on('click', '.billing-company', this, this.selectBillingCompany);
            $(document).on('click', '.shipping-address', this, this.selectShippingAddress);
            $(document).on('click', '.payment-method-btn', this, this.selectPaymentMethod);
            $(document).on('click', '.shipping-method-btn', this, this.selectShippingMethod);
            $(document).on('click', '.packaging-method-btn', this, this.selectPackagingMethod);

            $(document).on('click', '#add-new-billing-company', this, this.addNewCompanyModal);
			$(document).on('click', '#cancel-new-company', function() {
				$('#new-company-wrapper').hide();
				$('#add-new-billing-company').parent().show();
			});
            $(document).on('click', '#save-new-company', this, this.saveCompany);

			$(document).on('click', '#add-new-shipping-address', this, this.addNewAddressModal);
			$(document).on('click', '#cancel-new-address', function() {
				$('#shipping-address-wrapper').hide();
				$('#add-new-shipping-address').show();
			});
            $(document).on('click', '#save-new-address', this, this.saveAddress);

			$(document).on('click', '#add-new-billing-address', this, this.addNewBillingAddress);
			$(document).on('click', '#cancel-new-billing-address', function() {
				$('#new-company-wrapper').hide();
				$('#add-new-billing-company').parent().show();
			});
            $(document).on('click', '#save-new-billing-address', this, this.saveBillingAddress);

			$(document).on('click', '#send-order', this, this.sendOrder);

            $(document).on('change', '#address_county_id', this, this.getCities);
            $(document).on('change', '#billing_county_id', this, this.getBillingCities);
            $(document).on('change', '#company_county', this, this.getCompanyCities);

            $(document).on('change', '.billing-address-selector', this, function() {
				if ($(this).val() == 1) {
					$('#order-billing-container').hide();
				} else {
					$('#order-billing-container').show();
				}
			});

			$('#address_county_id').select2();
			$('#address_city_id').select2();

        },
		selectPackagingMethod(event) {
			const _this = event.data;
			$('#packaging-methods-wrapper').find('.packaging-method').removeClass('active');
			var id = $(this).data('id');
			$('#packaging-method-' + id).addClass('active');
			$('#packaging_method').val(id);

			var values = '_token=' + $("meta[name='csrf-token']").attr("content");
			values += '&packaging_method=' + $('#packaging_method').val();
			$.ajax({
				type: "POST",
				url: baseURL + "/checkout/packaging-fee",
				data: values,
				success: function(response) {
					if (response.status == 1) {
						$('.packaging-method-title').text(response.title);
						$('.packaging-method-fee span').text(response.amount > 0 ? response.amount + ' LEI' : 'Gratuit');
						$('.order-total').text(response.total + ' LEI');
					}
				},
				error(error) {

				}
			});
		},
		submitForm() {
			$('#order-form').submit();
        },
		getShippingFee() {
			var values = '_token=' + $("meta[name='csrf-token']").attr("content");
			values += '&address_id=' + $('#shipping_address').val();
			values += '&shipping_method=' + $('#shipping_method').val();
			$.ajax({
				type: "POST",
				url: baseURL + "/checkout/shipping-fee",
				data: values,
				success: function(response) {
					if (response.status == 1) {
						$('.shipping-amount').text(response.shipping_amount > 0 ? response.shipping_amount + ' LEI' : 'Gratuit');
						$('.order-total').text(response.total + ' LEI');
						$('.amount-to-free-shipping').text('Adauga produse de inca '+response.amount_to_free_shipping+' lei si ai transport gratuit');
						if (response.amount_to_free_shipping < 1) {
							$('.amount-to-free-shipping').hide();
						} else {
							$('.amount-to-free-shipping').show();
						}
					}
				},
				error(error) {

				}
			});
		},
		getCompanyCities() {
			$('#company-city').find('option:not(:first)').remove();
			let cities = $('#company-county option:selected').data('cities');
			cities = Object.keys(cities).map(key => {
				return cities[key];
			});
			for (var i in cities) {
				$('#company-city').append('<option value="'+cities[i].id+'">'+cities[i].name+'</option>');
			}
        },
		getBillingCities() {
			$('#billing_city_id').find('option:not(:first)').remove();
			let cities = $('#billing_county_id option:selected').data('cities');
			cities = Object.keys(cities).map(key => {
				return cities[key];
			});
			for (var i in cities) {
				$('#billing_city_id').append('<option value="'+cities[i].id+'">'+cities[i].name+'</option>');
			}
        },
		getCities() {
			$('#address_city_id').find('option:not(:first)').remove();
			let cities = $('#address_county_id option:selected').data('cities');
			cities = Object.keys(cities).map(key => {
				return cities[key];
			});
			for (var i in cities) {
				$('#address_city_id').append('<option value="'+cities[i].id+'">'+cities[i].name+'</option>');
			}
        },
		billingTab(event) {
			$('#person_type').val($(this).data('person-type'));
		},
		selectBillingAddress(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if(!id) { return false; }

			$('#billing-addresses-wrapper').find('.billing-address-wrapper').removeClass('active');
			$('#billing-address-' + id).addClass('active');

			$('#billing_address_id').val(id);

			$('#person_type').val(0);

			//reset billing company
			$('#billing-companies-wrapper').find('.billing-company-wrapper').removeClass('active');
			$('#billing_company').val(0);
		},
		selectBillingCompany(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if(!id) { return false; }

			$('#billing-companies-wrapper').find('.billing-company-wrapper').removeClass('active');
			$('#billing-company-' + id).addClass('active');

			$('#billing_company').val(id);

			$('#person_type').val(1);

			//reset billing address
			$('#billing-addresses-wrapper').find('.billing-address-wrapper').removeClass('active');
			$('#billing_address_id').val(0);
		},
		selectShippingAddress(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if(!id) { return false; }

			$('#shipping-addresses-wrapper').find('.shipping-address-wrapper').removeClass('active');
			$('#shipping-address-' + id).addClass('active');

			$('#shipping_address').val(id);

			_this.getShippingFee();
		},
		selectShippingMethod(event) {
			const _this = event.data;
			$('#shipping-methods-wrapper').find('.shipping-method').removeClass('active');
			var id = $(this).data('id');
			$('#shipping-method-' + id).addClass('active');
			$('#shipping_method').val(id);

			_this.getShippingFee();
		},
		selectPaymentMethod() {
			const _this = event.data;
			$('#payment-methods-wrapper').find('.payment-method').removeClass('active');
			var id = $(this).data('id');
			$('#payment-method-' + id).addClass('active');
			$('#payment_method').val(id);

			var values = '_token=' + $("meta[name='csrf-token']").attr("content");
			values += '&payment_method=' + $('#payment_method').val();
			$.ajax({
				type: "POST",
				url: baseURL + "/checkout/payment-fee",
				data: values,
				success: function(response) {
					if (response.status == 1) {
						$('.payment-method-fee span').text(response.amount > 0 ? response.amount + ' LEI' : 'Gratuit');
						$('.order-total').text(response.total + ' LEI');
					}
				},
				error(error) {

				}
			});
		},
		addNewCompanyModal(event) {
			const _this = event.data;

			$('#new-company-wrapper').show();
			$(this).parent().hide();
			$('#company_country_id').select2();
		},
		saveCompany(event) {
            const _this = event.data;
			const type = $(this).data('type');
			let element = this;

            if (_this.isLoadingOrder) {
                return false;
            }

            $('.form-new-company').find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#company_name').val() == '') {
				$('#company_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#company_cui_number').val() == '') {
				$('#company_cui_number').addClass('is-invalid');
				errors = true;
			}
			if ($('#company_address').val() == '') {
				$('#company_address').addClass('is-invalid');
				errors = true;
			}
			// if ($('#company_country_id option:selected').val() == '') {
			// 	$('#company_country_id').addClass('is-invalid');
			// 	errors = true;
			// }
			if ($('#company_city_id').val() == '') {
				$('#company_city_id').addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoadingOrder = true;

            var values = '_token=' + $('#_token_company').val();
            values += '&name=' + $('#company_name').val();
			values += '&nr_reg_com=' + $('#company_nr_reg_com').val();
            values += '&cui_number=' + $('#company_cui_number').val();
            values += '&address=' + $('#company_address').val();
			//values += '&country_id=' + $('#company_country_id option:selected').val();
            values += '&city_id=' + $('#company_city_id').val();
            values += '&bank=' + $('#company_bank').val();
            values += '&bank_account=' + $('#company_bank_account').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/company`,
                data: values,
                beforeSend: function() {
                    _this.isLoadingOrder = true;
                },
                complete: function() {
                    _this.isLoadingOrder = false;
                },
                success: function(response, xhr) {
                    _this.isLoadingOrder = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#company_"+errorKey).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {
						$('#billing-companies-wrapper').find('p').remove();

						$('#billing-companies-wrapper').find('.billing-company-wrapper').removeClass('active');
						$('#billing_company').val(response.data.id);

						$('#person_type').val(1);

						//reset billing address
						$('#billing-addresses-wrapper').find('.billing-address-wrapper').removeClass('active');
						$('#billing_address_id').val(0);

						var rowHtml = `<div id="billing-company-${response.data.id}" class="billing-company-wrapper section-box active">
							<div class="row align-items-center justify-content-between gy-3">
								<div class="col-md-9 col-xxl-8">
									<h6 class="box-subtitle">${response.data.name} - ${response.data.cui}</h6>
									<p>${response.data.address} ${response.data.city_id}</p>
								</div>
								<div class="col-md-3">
									<div class="box-icon mx-auto ms-md-auto mx-md-0">
										<i class="fas fa-check"></i>
									</div>
								</div>
							</div>
							<a href="javascript:void(0)" data-id="${response.data.id}" class="billing-company stretched-link"></a>
						</div>`;
						$('#billing-companies-wrapper').prepend(rowHtml);

						$('.form-new-company').find('.form-control').val('');
                        $('#company_country_id').val('');

						$('#new-company-wrapper').hide();
						$('#add-new-billing-company').parent().show();

						return;
                    }
                },
                error(error) {
                    _this.isLoadingOrder = false;
                },
            });
        },
		addNewBillingAddress(event) {
			const _this = event.data;

			$('#billing-address-wrapper').show();
			$(this).hide();
			$('#billing-address-county_id').select2();
			$('#billing-address-city_id').select2();
		},
		saveBillingAddress(event) {
            const _this = event.data;
			let element = this;

            if (_this.isLoadingOrder) {
                return false;
            }

            $('.form-new-billing-address').find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#billing_first_name').val() == '') {
				$('#billing_first_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#billing_last_name').val() == '') {
				$('#billing_last_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#billing_phone').val() == '') {
				$('#billing_phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#billing_email').val() == '') {
				$('#billing_email').addClass('is-invalid');
				errors = true;
			}
			if ($('#billing_county_id option:selected').val() == '') {
				$('#billing_county_id').addClass('is-invalid');
				errors = true;
			}
			if ($('#billing_city_id option:selected').val() == '') {
				$('#billing_city_id').addClass('is-invalid');
				errors = true;
			}
			if ($('#billing_address').val() == '') {
				$('#billing_address').addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoadingOrder = true;

            var values = '_token=' + $("meta[name='csrf-token']").attr("content");
            values += '&first_name=' + $('#billing_first_name').val();
            values += '&last_name=' + $('#billing_last_name').val();
            values += '&phone=' + $('#billing_phone').val();
            values += '&email=' + $('#billing_email').val();
            values += '&county_id=' + $('#billing_county_id option:selected').val();
            values += '&city_id=' + $('#billing_city_id option:selected').val();
            values += '&address=' + $('#billing_address').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/address`,
                data: values,
                beforeSend: function() {
                    _this.isLoadingOrder = true;
                },
                complete: function() {
                    _this.isLoadingOrder = false;
                },
                success: function(response, xhr) {
                    _this.isLoadingOrder = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#billing_"+errorKey).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {
						$('#billing-addresses-wrapper').find('.empty').remove();

						$('#billing-addresses-wrapper').find('.billing-address-wrapper').removeClass('active');
						$('#billing_address_id').val(response.data.id);

						var rowHtml = `<div id="shipping-address-${response.data.id}" class="shipping-address-wrapper section-box">
							<div class="row align-items-center justify-content-between gy-3">
								<div class="col-md-9 col-xxl-8">
									<h6 class="box-title">Persoana de contact</h6>
									<h6 class="box-subtitle">${response.data.first_name} ${response.data.last_name} - ${response.data.phone}</h6>
									<p>Adresa de livrare</p>
									<p>${response.data.address} ${response.data.county_name}, ${response.data.city_name}</p>
								</div>
								<div class="col-md-3">
									<div class="box-icon mx-auto ms-md-auto mx-md-0">
										<i class="fas fa-check"></i>
									</div>
								</div>
							</div>
							<a href="javascript:void(0)" data-id="${response.data.id}" class="shipping-address stretched-link"></a>
						</div>`;
						$('#shipping-addresses-wrapper').prepend(rowHtml);

						var rowHtmlBillingAddress = `<div id="billing-address-${response.data.id}" class="billing-address-wrapper section-box active">
							<div class="row align-items-center justify-content-between gy-3">
								<div class="col-md-9 col-xxl-8">
									<h6 class="box-title">Persoana fiziza</h6>
									<h6 class="box-subtitle">${response.data.first_name} ${response.data.last_name} - ${response.data.phone}</h6>
									<p>Adresa</p>
									<p>${response.data.address} ${response.data.county_name}, ${response.data.city_name}</p>
								</div>
								<div class="col-md-3">
									<div class="box-icon mx-auto ms-md-auto mx-md-0">
										<i class="fas fa-check"></i>
									</div>
								</div>
							</div>
							<a href="javascript:void(0)" data-id="${response.data.id}" class="billing-address stretched-link"></a>
						</div>`;
						$('#billing-addresses-wrapper').prepend(rowHtmlBillingAddress);

                        $('.form-new-billing-address').find('.form-control').val('');
                        $('#billing_county_id').val('');
						$('#billing_city_id').find('option:not(:first)').remove();

						$('#new-company-wrapper').hide();
						$('#add-new-billing-company').parent().show();
						$('#cancel-new-billing-address').show();
						$('#cancel-new-company').show();

						$('#shipping-address-wrapper').hide();
						$('#add-new-shipping-address').show();
						$('#cancel-new-address').show();

						return;
                    }
                },
                error(error) {
                    _this.isLoadingOrder = false;
                },
            });
        },
		addNewAddressModal(event) {
			const _this = event.data;

			$('#shipping-address-wrapper').show();
			$(this).hide();
			$('#address-county_id').select2();
			$('#address-city_id').select2();
		},
		saveAddress(event) {
            const _this = event.data;
			let element = this;

            if (_this.isLoadingOrder) {
                return false;
            }

            $('.form-new-address').find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#address_first_name').val() == '') {
				$('#address_first_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#address_last_name').val() == '') {
				$('#address_last_name').addClass('is-invalid');
				errors = true;
			}
			if ($('#address_phone').val() == '') {
				$('#address_phone').addClass('is-invalid');
				errors = true;
			}
			if ($('#address_email').val() == '') {
				$('#address_email').addClass('is-invalid');
				errors = true;
			}
			if ($('#address_county_id option:selected').val() == '') {
				$('#address_county_id').addClass('is-invalid');
				errors = true;
			}
			if ($('#address_city_id option:selected').val() == '') {
				$('#address_city_id').addClass('is-invalid');
				errors = true;
			}
			if ($('#address_address').val() == '') {
				$('#address_address').addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoadingOrder = true;

            var values = '_token=' + $("meta[name='csrf-token']").attr("content");
            values += '&first_name=' + $('#address_first_name').val();
            values += '&last_name=' + $('#address_last_name').val();
            values += '&phone=' + $('#address_phone').val();
            values += '&email=' + $('#address_email').val();
            values += '&county_id=' + $('#address_county_id option:selected').val();
            values += '&city_id=' + $('#address_city_id option:selected').val();
            values += '&address=' + $('#address_address').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/address`,
                data: values,
                beforeSend: function() {
                    _this.isLoadingOrder = true;
                },
                complete: function() {
                    _this.isLoadingOrder = false;
                },
                success: function(response, xhr) {
                    _this.isLoadingOrder = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#address_"+errorKey).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {
						$('#shipping-addresses-wrapper').find('.empty').remove();

						$('#shipping-addresses-wrapper').find('.shipping-address-wrapper').removeClass('active');
						$('#shipping_address').val(response.data.id);

						var rowHtml = `<div id="shipping-address-${response.data.id}" class="shipping-address-wrapper section-box active">
							<div class="row align-items-center justify-content-between gy-3">
								<div class="col-md-9 col-xxl-8">
									<h6 class="box-title">Persoana de contact</h6>
									<h6 class="box-subtitle">${response.data.first_name} ${response.data.last_name} - ${response.data.phone}</h6>
									<p>Adresa de livrare</p>
									<p>${response.data.address} ${response.data.county_name}, ${response.data.city_name}</p>
								</div>
								<div class="col-md-3">
									<div class="box-icon mx-auto ms-md-auto mx-md-0">
										<i class="fas fa-check"></i>
									</div>
								</div>
							</div>
							<a href="javascript:void(0)" data-id="${response.data.id}" class="shipping-address stretched-link"></a>
						</div>`;
						$('#shipping-addresses-wrapper').prepend(rowHtml);

						var rowHtmlBillingAddress = `<div id="billing-address-${response.data.id}" class="billing-address-wrapper section-box">
							<div class="row align-items-center justify-content-between gy-3">
								<div class="col-md-9 col-xxl-8">
									<h6 class="box-title">Persoana fiziza</h6>
									<h6 class="box-subtitle">${response.data.first_name} ${response.data.last_name} - ${response.data.phone}</h6>
									<p>Adresa</p>
									<p>${response.data.address} ${response.data.county_name}, ${response.data.city_name}</p>
								</div>
								<div class="col-md-3">
									<div class="box-icon mx-auto ms-md-auto mx-md-0">
										<i class="fas fa-check"></i>
									</div>
								</div>
							</div>
							<a href="javascript:void(0)" data-id="${response.data.id}" class="billing-address stretched-link"></a>
						</div>`;
						$('#billing-addresses-wrapper').prepend(rowHtmlBillingAddress);

                        $('.form-new-address').find('.form-control').val('');
                        $('#address_county_id').val('');
						$('#address_city_id').find('option:not(:first)').remove();

						$('#shipping-address-wrapper').hide();
						$('#add-new-shipping-address').show();
						$('#cancel-new-address').show();

						// $('#billing-address-wrapper').hide();
						// $('#add-new-billing-address').show();
						// $('#cancel-new-billing-address').show();

						$('#add-new-billing-company').parent().show();
						$('#new-company-wrapper').hide();
						$('#cancel-new-billing-address').show();
						$('#cancel-new-company').show();

						_this.getShippingFee();

						return;
                    }
                },
                error(error) {
                    _this.isLoadingOrder = false;
                },
            });
        },
		sendOrder(event) {
			const _this = event.data;

			$('#order-form').submit();
		},
    };

    if ($('.order-page').length) {
        order.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/order.js